/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, March 2020
 */

let promise: Promise<void>;

/**
 * A queueMicrotask ponyfill.
 *
 * @param cb Callback to queue.
 */
export function queueMicrotask(cb: () => void): void {
    // This if statement is checking the existance of a promise so it's ok to disable this rule.
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    if (!promise) {
        promise = Promise.resolve();
    }
    promise.then(cb).catch(err => {
        // istanbul ignore next
        setTimeout(() => {
            throw err;
        }, 0);
    });
}



// WEBPACK FOOTER //
// ./src/packages/core/lib/ponyfills/queueMicrotask.ts